"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GroupHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _UsersInGroup = _interopRequireDefault(require("./UsersInGroup"));

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GroupHeader = function GroupHeader(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3 text-center font-bold mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4 text-left border-b-2 text-xl"
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Groups in Project"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-1"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    small: true,
    showClear: true,
    placeholder: "Search groups...",
    value: value,
    onChange: onChange
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 border-b-2 flex justify-center items-end"
  }, "Adjust Project Authority"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 border-b-2 flex justify-center items-end"
  }, "Remove from Project"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 border-b-2 flex justify-center items-end"
  }, "Delete Group"));
};

exports.GroupHeader = GroupHeader;

var verify = function verify(currAL, newAL) {
  return !isNaN(newAL) && currAL !== newAL && newAL >= 0 && newAL <= 10;
};

var _default = function _default(_ref2) {
  var group = _ref2.group,
      project = _ref2.project,
      adjustAuthLevel = _ref2.adjustAuthLevel,
      deleteGroup = _ref2.deleteGroup,
      removeFromProject = _ref2.removeFromProject,
      props = _objectWithoutProperties(_ref2, ["group", "project", "adjustAuthLevel", "deleteGroup", "removeFromProject"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      opened = _React$useState2[0],
      setOpened = _React$useState2[1],
      toggle = _react["default"].useCallback(function () {
    return setOpened(!opened);
  }, [opened]),
      Project = group.projects.reduce(function (a, c) {
    return c.project_name === project ? c : a;
  }, {}),
      _React$useState3 = _react["default"].useState((0, _lodash["default"])(Project, "auth_level", -1)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      authLevel = _React$useState4[0],
      setAuthLevel = _React$useState4[1];

  var submit = _react["default"].useCallback(function (e) {
    e.preventDefault();
    adjustAuthLevel(group.name, authLevel);
  }, [adjustAuthLevel, group.name, authLevel]);

  var theme = (0, _avlComponents.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n        mb-1 py-1 px-2 rounded ".concat(opened ? theme.accent1 : "")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n              px-2 py-1 mr-1 cursor-pointer rounded flex justify-center\n              hover:".concat(theme.accent2, " ").concat(theme.transition, "\n            "),
    onClick: toggle
  }, opened ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa fa-minus"
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa fa-plus"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1"
  }, group.name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3"
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: submit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-6"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    type: "number",
    min: "0",
    max: "10",
    required: true,
    value: authLevel,
    onChange: setAuthLevel
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-6"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonBlock",
    type: "submit",
    disabled: !verify(+Project.auth_level, +authLevel)
  }, "adjust"))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-3 flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    showConfirm: true,
    onClick: function onClick(e) {
      return removeFromProject(group.name);
    }
  }, "remove")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonDanger",
    showConfirm: true,
    onClick: function onClick(e) {
      return deleteGroup(group.name);
    }
  }, "delete"))), !opened ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-10 mt-2"
  }, /*#__PURE__*/_react["default"].createElement(_UsersInGroup["default"], _extends({
    group: group
  }, props))));
};

exports["default"] = _default;